import { render, staticRenderFns } from "./AdditionalPaymentDialog.vue?vue&type=template&id=0a5e8567"
import script from "./AdditionalPaymentDialog.vue?vue&type=script&lang=js"
export * from "./AdditionalPaymentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports